import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getLetterListApiCall = createAsyncThunk("letterList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: letterList } = await API.getLatterListApi(submitData);
        //  console.log("*********************************************",letterList);
        dispatch(setLoader(false))
        return letterList;
    } catch (error) {
        throw error;
    }
});

export const editLetterDataApiCall = createAsyncThunk("editClientData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        //console.log("000000000000000000000000000000000000",submitData);
        
        const { data: editLatterData, code, message } = await API.updateLatterApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editLatterData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    letterList: {
        data: [],
        error: null,
    },
    editLatterData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const latterSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getLetterListApiCall.fulfilled, (state, action) => {
                state.letterList.data = action.payload;
            })
            .addCase(getLetterListApiCall.rejected, (state, action) => {
                state.letterList.error = action.error.message;
            })
            .addCase(editLetterDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editLatterData.data = data;
                state.editLatterData.message = message;
                state.editLatterData.code = code;
            })
            .addCase(editLetterDataApiCall.rejected, (state, action) => {
                state.editLatterData.error = action.error.message;
            });
    },
});

export default latterSlice.reducer;